type LinkedMessage = {
  campaign?: {
    id: string;
    name: string;
    status?: string;
    pending_drafts?: Array<{ id: string }>;
  } | null;
  current_content?: { content_email_version_id?: string | null } | null;
};

type LinkRow = { message?: LinkedMessage | null };

export type NdAttachment = {
  campaignId: string;
  campaignName: string;
  /** The message's published row is pinned to a version — review-submit or
   *  activation froze it, and deny/withdraw/revert-to-draft unfreezes it. */
  isFrozen: boolean;
  /** Drives copy: "active campaign" vs "campaign under review". */
  isUnderReview: boolean;
};

/**
 * The ND campaign a content email is attached to, if any. An email has at most
 * one link row (unique per email at the schema level); a link to a journey or
 * standalone message carries no campaign and reads as unattached here.
 */
export function ndAttachment(
  email: { content_email_message_links?: LinkRow[] | null } | null | undefined,
): NdAttachment | null {
  const message = email?.content_email_message_links?.[0]?.message;
  const campaign = message?.campaign;
  if (!campaign) return null;
  return {
    campaignId: campaign.id,
    campaignName: campaign.name,
    isFrozen: message?.current_content?.content_email_version_id != null,
    isUnderReview: (campaign.pending_drafts?.length ?? 0) > 0,
  };
}
